import httpClient from '../../../api/httpClient';
import API_CONFIG from '../../../config/api.config';
import { 
  ChartOfAccount, 
  ChartOfAccountListResponse, 
  ChartOfAccountFilterParams,
  ChartOfAccountFormData,
  AccountType
} from '../types/chart-of-accounts.types';

export const chartOfAccountsApi = {
  /**
   * Get paginated list of chart of accounts
   */
  getChartOfAccounts: async (params: ChartOfAccountFilterParams): Promise<ChartOfAccount[]> => {
    const response = await httpClient.get<ChartOfAccount[]>(API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS, { params });
    return response.data;
  },

  /**
   * Get a single chart of account by ID
   */
  getChartOfAccountById: async (id: string): Promise<ChartOfAccount> => {
    const response = await httpClient.get<ChartOfAccount>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/${id}`);
    return response.data;
  },

  /**
   * Get chart of account by account code
   */
  getChartOfAccountByCode: async (accountCode: string): Promise<ChartOfAccount> => {
    const response = await httpClient.get<ChartOfAccount>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/code/${accountCode}`);
    return response.data;
  },

  /**
   * Get chart of accounts by type
   */
  getChartOfAccountsByType: async (type: AccountType): Promise<ChartOfAccount[]> => {
    const response = await httpClient.get<ChartOfAccount[]>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/type/${type}`);
    return response.data;
  },

  /**
   * Create a new chart of account
   */
  createChartOfAccount: async (data: ChartOfAccountFormData): Promise<ChartOfAccount> => {
    const response = await httpClient.post<ChartOfAccount>(API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS, data);
    return response.data;
  },

  /**
   * Update an existing chart of account
   */
  updateChartOfAccount: async (id: string, data: Partial<ChartOfAccountFormData>): Promise<ChartOfAccount> => {
    const response = await httpClient.patch<ChartOfAccount>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/${id}`, data);
    return response.data;
  },

  /**
   * Delete a chart of account (soft delete)
   */
  deleteChartOfAccount: async (id: string): Promise<ChartOfAccount> => {
    const response = await httpClient.delete<ChartOfAccount>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/${id}`);
    return response.data;
  },

  /**
   * Update chart of account status
   */
  updateChartOfAccountStatus: async (id: string, isActive: boolean): Promise<ChartOfAccount> => {
    const response = await httpClient.patch<ChartOfAccount>(`${API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS}/${id}/status`, null, {
      params: { isActive }
    });
    return response.data;
  },

  /**
   * Search chart of accounts
   */
  searchChartOfAccounts: async (searchTerm: string): Promise<ChartOfAccount[]> => {
    const response = await httpClient.get<ChartOfAccount[]>(API_CONFIG.ENDPOINTS.CHART_OF_ACCOUNTS, {
      params: { search: searchTerm }
    });
    return response.data;
  }
};
